/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type LinkActionActionType = (typeof LinkActionActionType)[keyof typeof LinkActionActionType];

export const LinkActionActionType = {
  link: 'link',
} as const;
